import React, { useState, useEffect, Fragment, useCallback, useMemo } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Row, Col, Input, Button, Table, Menu, Dropdown, Select, Skeleton, Tag, Space, Card, Tooltip, DatePicker, Typography, Popover } from 'antd';
import { withRouter } from 'react-router-dom';
import { ColumnProps } from 'antd/es/table';
import { Option } from 'rc-select';
import './table-list.less';
import {
  MoreOutlined,
  SearchOutlined,
  PlusOutlined,
  PlusCircleTwoTone,
  MinusCircleTwoTone,
  QuestionCircleFilled,
  ReloadOutlined,
  ImportOutlined,
  DeleteOutlined,
  SettingOutlined
} from '@ant-design/icons';
import TableListModal from './modal';
import { get_db, set_db } from '../../http-worker/db-func';
import Text from 'antd/lib/typography/Text';
import { key_to_title, prevent } from '../../shared-functions';
import { DefaultRecordType } from 'rc-table/lib/interface';
import { dropdown_menu_item, operation_type, props_type, sorter_type, filter_title } from './interface';
import { VisibleDelayed } from '../../shared-functions';
import { MenuInfo } from 'rc-menu/lib/interface';

const { RangePicker } = DatePicker;
const TableList: React.FC<props_type> = (props: props_type) => {
  const [search_value, set_search_value]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>('');
  const [page_number, set_page_number]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(1);
  const [page_size, set_page_size]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(12);
  const [page_size_db, set_page_size_db]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(0);
  const [default_sorter, set_default_sorter]: [sorter_type, React.Dispatch<React.SetStateAction<sorter_type>>] = useState<sorter_type>({} as sorter_type);
  const [action_id, set_action_id]: [number | undefined, React.Dispatch<React.SetStateAction<number | undefined>>] = useState<number | undefined>();

  const // [is_public, set_is_public]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(0),
    // [caption, set_caption]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
    path = props?.path ? props.path : props.history.location.pathname.substring(1).replace(/(\/create|\/edit)/g, '');

  const position: number = useMemo(() => path.lastIndexOf('/') + 1, [path]);
  const list_type: string = useMemo(() => path.substr(position, path.length - position).replace(/-/gi, '_'), [path, position]);

  const {
    back_to_first_page,
    titles,
    items,
    selectable,
    selectable_type,
    table_desc,
    dropdown_menus,
    no_create_button,
    has_import_button,
    has_general_button,
    general_button_icon,
    no_refresh_button,
    has_batch_delete_button,
    has_backup_button,
    no_show_page_size,
    hide_select_all,
    has_on_row_visable,
    get_checkbox_props,
    no_search,
    operations,
    no_title,
    visible,
    selected_row_keys,
    filter_operations,
    on_select,
    row_selection_change,
    get_sub,
    set_items,
    set_action,
    set_item_selected,
    set_visible,
    set_loading_done_items,
    set_selectable,
    set_selected_row_keys,
    set_selected_rows,
    help,
    operations_to_hide,
    custom_col,
    custom_caption,
    is_row_operation,
    please_input_name,
    default_page_size,
    no_sort_col,
    date_pick,
    default_sorter_col
  }: props_type = useMemo(() => props, [props]);

  const operation = useMemo(() => operations?.(), [operations]);
  const { formatMessage } = useMemo(() => props.intl, [props.intl]);
  const [expanded_keys, set_expanded_keys]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState<string[]>([]);
  const [has_filter, set_has_filter]: [1 | undefined, React.Dispatch<React.SetStateAction<1 | undefined>>] = useState<1 | undefined>();

  const // 切换页码
    changePage = useCallback(
      (pageNumber: number) => {
        props?.set_page_number?.(pageNumber) || set_page_number(pageNumber);
      },
      // eslint-disable-next-line
      [set_page_number,props?.set_page_number]
    );

  //更改分页器pageSize
  useEffect((): void => {
    default_page_size && set_page_size(default_page_size);
    !!page_size_db && set_page_size(page_size_db);
  }, [default_page_size, page_size_db]);

  // 当新建或者编辑时候，返回第一页
  useEffect((): void => {
    if (back_to_first_page) {
      props?.set_page_number?.(1) || set_page_number(1);
    }
    // eslint-disable-next-line
  }, [back_to_first_page, set_page_number, props?.set_page_number]);

  useEffect((): void => {
    default_sorter_col
      ? set_default_sorter(default_sorter_col)
      : get_db([
          { key: list_type, func: set_default_sorter },
          { key: 'page_size_db', func: set_page_size_db }
        ]);
  }, [list_type, default_sorter_col]);

  useEffect((): void => {
    set_search_value('');
  }, [items]);

  // 三點按鈕彈出選單
  const menu = useMemo((): JSX.Element => {
    let operations_format: operation_type[] | undefined = filter_operations && filter_operations.length ? filter_operations : operation;
    return !visible ? (
      <Menu
        className='p-10'
        onMouseEnter={(e: any) => {
          e.stopPropagation();
        }}
      >
        {operations_format &&
          operations_format.map(
            ({ caption }: operation_type, index: number) =>
              !['create', 'select', 'expose', 'import', 'batch_delete'].concat(operations_to_hide || []).includes(caption) && (
                <Menu.Item
                  key={caption}
                  className='font-9 p-6'
                  onClick={({ domEvent }: MenuInfo) => {
                    domEvent.stopPropagation();
                    const operation = (operations_format || [])[index];
                    if (operation) {
                      const { custom_action, action } = operation;
                      if (custom_action) custom_action({ props });
                      else {
                        set_action_id(index);
                        set_action && set_action(action);
                        // set_caption(caption);
                        props.set_action_id?.(index);
                        set_visible && set_visible(1);
                      }
                    }
                  }}
                >
                  <FormattedMessage id={caption} />
                </Menu.Item>
              )
          )}
      </Menu>
    ) : (
      <Fragment />
    );
  }, [visible, props, operation, operations_to_hide, set_action, set_visible, filter_operations]);

  //一行按钮选单
  const menu_row = useCallback(
    (item: unknown | any): (JSX.Element | boolean)[] | undefined => {
      return operation?.map(
        ({ caption, icon }: operation_type, index: number) =>{
          return !['create', 'select', 'expose', 'import'].concat(operations_to_hide || item?.operations_to_hide || []).includes(caption) && (
            <Button
              key={caption}
              // className='font-8'
              className={`font-8 ${item?.forbid_button?.includes(caption) ? 'forbid-btn' : ''}`}
              type='link'
              disabled={item?.is_disabled || item?.forbid_button?.includes(caption)}
              // disabled={false}
              onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                event.stopPropagation();
                setTimeout(() => {
                  const operation_selected = operation[index];
                  if (operation_selected) {
                    const { custom_action } = operation_selected;
                    if (custom_action) custom_action({ props, item });
                    else {
                      set_action_id(index);
                      set_action?.(operation_selected.action);
                      // set_caption(caption);
                      props.set_action_id?.(index);
                      set_visible && set_visible(1);
                    }
                  }
                }, 100);
              }}
            >
              {icon ? (
                caption === 'copy_url'?
                // <span>{icon}</span>
                <Popover content={
                  // content
                  <div className='copy_title'>
                  {Array.isArray(item?.items?.[0]?.external_urls)
                    &&
                   item?.items?.[0]?.external_urls.map((item: string)=>(
                      <a target='_blank' rel="noopener noreferrer" href={'https://'+item}><Typography.Paragraph copyable>{item}</Typography.Paragraph></a>
                   ))
                  }
                </div>
                }>{icon}</Popover>
                :
                <Tooltip title={formatMessage({ id: caption })}>
                  <span>{icon}</span>
                </Tooltip>
              ) : (
                <FormattedMessage id={caption} />
              )}
            </Button>
          )}
      );
    },
    [props, operation, operations_to_hide, set_action, set_visible, formatMessage]
  );

  const on_select_local = useCallback(
    (record: any) => {
      on_select && on_select(record);
      operation && set_action_id(operation.findIndex(({ caption }: operation_type) => caption === 'select'));
      set_item_selected && set_item_selected(record);
      !has_batch_delete_button && set_visible && set_visible(1);
    },
    [set_action_id, operation, set_item_selected, set_visible, on_select, has_batch_delete_button]
  );

  const dropdown_menu_el = useMemo((): JSX.Element | false => {
    const col_width: any[] = dropdown_menus?.map((item: any) => item?.width)?.filter((item: any) => !!item) || [];
    const cols = [
      ...(dropdown_menus?.map(
        ({ list, caption, width, value, change_event, no_refresh, has_all, dropdown_menu_element }: dropdown_menu_item): JSX.Element => (
          <Col xl={width || 4} key={caption}>
            <Col sm={24} className='dropdown_caption px-0'>
              {formatMessage({ id: caption })}
            </Col>
            <Select
              showSearch
              className='w-100'
              value={has_all && !value ? '' : value ? value : list?.[0]?.id}
              disabled={!list?.length}
              optionFilterProp='children'
              dropdownRender={(menu) => (
                <Fragment>
                  {dropdown_menu_element?.length && <div className='ant-select-item ant-select-item-group'>With Resources Only</div>}
                  {menu}
                </Fragment>
              )}
              placeholder={
                !list
                  ? formatMessage({ id: 'loading' })
                  : !list.length
                  ? formatMessage({ id: 'empty' })
                  : formatMessage({ id: 'please_select' }, { type: caption })
              }
              onChange={(event: string) => {
                change_event(event);
                !no_refresh && (set_loading_done_items ? set_loading_done_items() : set_items?.(undefined));
                // set_db("table_list", caption, value);
              }}
              filterOption={(input: string, option: any): boolean => (typeof option?.children === "string" ? option?.children: option?.key).toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {Array.isArray(list) &&
                [...(has_all ? [{ name: '' }] : []), ...(list || [])].map(({ id, name }: any) =>
                  !dropdown_menu_element?.length ? (
                    <Option value={id ?? name} key={id ?? name} title={name}>
                      {name || formatMessage({ id: 'all' })}
                    </Option>
                  ) : (
                    dropdown_menu_element(id, name)
                  )
                )}
            </Select>
          </Col>
        )
      ) || []),
      ...(!no_search
        ? [
            <Col
              xl={dropdown_menus ? 24 - ((dropdown_menus.length - col_width.length) * 4 + [].concat(...col_width).reduce((acc, val) => acc + val, 0)) : 24}
              key={2}
            >
              <Col sm={24} className='dropdown_caption  px-0'>
                {formatMessage({ id: please_input_name || 'name' })}
              </Col>
              <Input
                size='middle'
                allowClear={true}
                value={props?.search_value || search_value}
                className='w-100'
                placeholder={`${path.includes("backup") ?
                formatMessage({id: 'please_input'},
                  {type: please_input_name?.includes("id") ? formatMessage({id: please_input_name}) : formatMessage({id: please_input_name}).toLocaleLowerCase()}):
                formatMessage(
                  {
                    id: 'please_input_name'
                  },
                  { type: formatMessage({ id: path.includes('scale') ? 'quota' : please_input_name ?? list_type.slice(0, -1) }).toLocaleLowerCase() }
                )}`}
                suffix={<SearchOutlined />}
                onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                  if (event.keyCode === 13) event.preventDefault();
                }}
                onChange={(e): void => {
                  const { value } = e.target;
                  set_search_value(value);
                  props.set_search_value?.(value);
                }}
              />
            </Col>
          ]
        : []),
        ...(date_pick
          ?[
            <Col sm={10} lg={10} className='date_pick_col'>
              <Space>
                <RangePicker
                  format="YYYY-MM-DD"
                  className='w-100 date_pick'
                  getPopupContainer={() => document.getElementsByClassName('date_pick')[0] as HTMLElement}
                  onChange={(_text: any, date: [string, string]) => {
                    props?.set_dates?.( date? date : []);
                  }}
                />
              </Space>
            </Col>
          ]
        :[])
    ];
    return (
      <Row gutter={10} align='middle'>
        {cols}
      </Row>
    );
  }, [dropdown_menus, formatMessage, list_type, no_search, date_pick, path, please_input_name, props, search_value, set_items, set_loading_done_items]);

  const table = useMemo((): JSX.Element | false => {
    let title_processed: string;
    const column: ColumnProps<DefaultRecordType>[] | undefined = titles?.map((title_old: string | filter_title) => {
      title_processed = (typeof title_old === 'string' ? title_old : title_old?.title).replace('_stamp', '');
      const has_filter = typeof title_old !== 'string';
      const filter_is_multiple = has_filter && (title_old as filter_title)?.multiple;
      const fuzzy_match = has_filter && (title_old as filter_title)?.fuzzy_match;
      const filters = has_filter ? (title_old as filter_title)?.filters : [];
      const title: string = typeof title_old === 'string' ? title_old : title_old?.title;
      const custom_col_width: { [key: string]: string | number | undefined } = {};
      const custom_col_ellipsis: { [key: string]: string | number | undefined } = {};

      props.custom_col_style
      ?
        Object.entries(props.custom_col_style).forEach(([key, { width, ellipsis }]) => {
          custom_col_width[key] = width;
          key === 'operation' ? custom_col_width['operation'] = width : custom_col_width['operation'] = 100
          custom_col_ellipsis[key] = ellipsis;
        })
      :
        custom_col_width['operation'] = 100

      return {
        title: <span title={formatMessage({ id: title_processed})}>
          {formatMessage({id: title_processed})}
          </span>,
        dataIndex: title,
        key: title_processed,
        className: title === 'operation' && is_row_operation ? 'operation' : has_filter ? 'filter_column' : '',
        align: ['operation'].includes(title) ? 'center' : 'left',
        fixed: title === 'name' ? 'left' : ['operation'].includes(title) ? 'right' : undefined,
        ...(['refresh', 'operation'].concat(no_sort_col || []).includes(title)
          ? {}
          : {
              sorter: (a: any, b: any) => {
                const key = default_sorter && default_sorter?.column_key === title ? title : 'name';
                return (
                  (a &&
                    b &&
                    ({
                      string: () => (a?.[key] || '')?.localeCompare?.(b?.[key] || ''),
                      number: () => (a?.[key] || 0) - (b?.[key] || 0),
                      object: () => (Array.isArray?.(a?.[key] || b?.[key]) ? (a?.[key]?.join?.() || '').localeCompare?.(b?.[key]?.join?.() || '') : undefined)
                    } as { [key: string]: () => number })[typeof (a?.[key] ?? b?.[key])]?.()) ??
                  0
                );
                // switch (typeof (a[key] || b[key])) {
                //   case 'string':
                //     return (a[key] || '').localeCompare(b[key] || '');
                //   case 'number':
                //     return (a[key] || 0) - (b[key] || 0);
                //   case 'object':
                //     if (Array.isArray(a[key] || b[key])) return (a[key]?.join() || '').localeCompare(b[key]?.join() || '');
                //     return;
                //   default:
                //     return;
                // }
              },
              sortOrder: default_sorter && default_sorter.column_key === title ? default_sorter.order : undefined
            }),
        width: ({
          ...custom_col_width,
        } as { [key: string]: number })[title],

        ellipsis: custom_col_ellipsis,

        onCell: (record: DefaultRecordType, index?: number) => ({
          onClick: (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
            props.custom_oncell?.({ record, title, props, event, index });
          }
        }),

        //过滤
        ...(has_filter
          ? {
              filterMultiple: filter_is_multiple,
              onFilter: (value, record) => (fuzzy_match ? !!~record?.[title]?.indexOf?.(value) : record?.[title] === value),
              filters
            }
          : {}),
        // responsive: ["sm"],
        render: (item: any, record: any) => {
          let children: JSX.Element | string;

          if (Array.isArray(items) && items.length) {
            const children_arr: { [key: string]: (item?: any, record?: any, props?: any) => JSX.Element | string } = {
              name: (item: string) => (
                <span className='name' onClick={(e) => e.stopPropagation()}>
                  <Text
                    className='font-w-7'
                    copyable={{
                      text: item
                    }}
                  >
                    {item}
                  </Text>
                </span>
              ),

              status: (item: string) => (
                <div className='font-w-7'>
                  <Tag color={['active', 'online'].includes(item?.toLowerCase()) ? '#2bc41ab5' : 'lightgray'}>
                    <span className='tag_status'>{item}</span>
                  </Tag>
                </div>
              ),

              // 三點操作按鈕
              operation: () =>
                is_row_operation ? (
                  <div
                    onMouseOver={() => {
                      set_item_selected?.(record);
                    }}
                  >
                    <Space className="no-padding">{menu_row(record)}</Space>
                  </div>
                ) : (
                  <Dropdown overlay={menu} trigger={['click']} placement='bottomCenter'>
                    <Button
                      type='primary'
                      shape='circle'
                      onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                        prevent(event);
                        set_item_selected && set_item_selected(record);
                      }}
                      icon={<MoreOutlined />}
                    />
                  </Dropdown>
                ),

              // 重新獲取列表按鈕
              refresh: () => (
                <Button
                  type='primary'
                  shape='circle'
                  onClick={() => {
                    set_loading_done_items ? set_loading_done_items() : set_items?.(undefined);
                  }}
                  icon={<ReloadOutlined />}
                />
              ),
              ...custom_col
            };

            children = children_arr?.[title] ? children_arr[title]?.(item, record, set_action_id) : <span>{item}</span>;
          } else {
            children = <Skeleton className='ant-col-sm-10' paragraph={false} active></Skeleton>;
          }
          return {
            children,
            props: {
              'data-title': `${key_to_title(title)}: `
            }
          };
        }
      };
    });

    return (
      <div className={`management-table${no_title ? ' mb-20' : ''}`}>
        <Table
          columns={column}
          size='small'
          dataSource={
            ((Array.isArray(items)
              ? (items?.filter((item: any) =>
                  (item?.name || '').toLocaleLowerCase().includes((props?.search_value || search_value).toLocaleLowerCase().trim())
                ) as unknown)
              : []) as any[]) || [{ name: '' }]
          }
          // loading={Array.isArray(items) ? false : true}
          locale={{
                  filterConfirm: formatMessage({ id: 'ok'}),
                  filterReset: formatMessage({ id: 'reset'})
                }}
          {...(has_filter
            ? {}
            : {
                pagination: !no_show_page_size
                  ? {
                      pageSize: page_size,
                      // hideOnSinglePage: true,
                      showSizeChanger: true,
                      total: Array.isArray(items)
                        ? items.filter((item: any) =>
                            (item?.name || '').toLocaleLowerCase().includes((props?.search_value || search_value).toLocaleLowerCase().trim())
                          )?.length
                        : 0,
                      defaultCurrent: props?.page_number || page_number,
                      current: props?.page_number || page_number,
                      pageSizeOptions: ['6', '12', '20', '50', '100'],
                      onChange: (pageNumber: number) => {
                        changePage(pageNumber);
                      },
                      onShowSizeChange: (current: number, pageSize: number) => {
                        set_db('page_size_db', pageSize)
                        set_page_size(pageSize)
                        set_page_number(current);
                        props?.set_page_number?.(current);
                      },
                      showTotal: (total: any) => <FormattedMessage id='total_items' values={{ value: total }}></FormattedMessage>
                    }
                  : false
              })}
          rowKey={(item: any) => item?.id || item?.name}
          onChange={(_a: any, filters: any, { columnKey, order }: any) => {
            set_default_sorter?.({ column_key: columnKey, order });
            !default_sorter_col && set_db?.(list_type, { column_key: columnKey, order });
            const has_filter_new = Object?.values?.(filters)?.some((filter_key: any) => !!filter_key);
            set_has_filter(has_filter_new ? 1 : undefined);
          }}
          showSorterTooltip={false}
          {...(get_sub
            ? {
                expandedRowKeys: props?.expanded_keys || expanded_keys,
                expandIcon: ({ expanded, onExpand, record }) =>
                  expanded ? <MinusCircleTwoTone onClick={(e: any) => onExpand(record, e)} /> : <PlusCircleTwoTone onClick={(e: any) => onExpand(record, e)} />,
                onExpand: (expanded: boolean, record: any) => {
                  set_item_selected && set_item_selected(record);
                  props.on_expand?.(record);
                  if (!expanded) {
                    set_expanded_keys(['']);
                    props?.set_expanded_keys?.(['']);
                  } else {
                    set_expanded_keys([record?.id || record?.name]);
                    props?.set_expanded_keys?.([record?.id || record?.name]);
                  }
                },
                rowExpandable: (record: any) => !record?.is_expand,
                expandedRowRender: (record: any) => get_sub(record)
              }
            : {})}
          {...(selectable
            ? {
                rowClassName: 'pointer',
                ...(has_on_row_visable
                  ? {
                      onRow: (record: any) => ({
                        onClick: () => {
                          on_select_local(record);
                        }
                      })
                    }
                  : {}),
                rowSelection: {
                  type: selectable_type || 'checkbox',
                  columnWidth: 50,
                  selectedRowKeys: selected_row_keys,
                  hideSelectAll: !hide_select_all,
                  onChange: (selectedRowKeys, selectedRows) => {
                    set_visible && set_visible(undefined);
                    row_selection_change?.(selectedRowKeys, selectedRows);
                    set_selected_row_keys && set_selected_row_keys(selectedRowKeys);
                    set_selected_rows && set_selected_rows(selectedRows);
                  },
                  onSelect: (record: any) => {
                    on_select_local(record);
                  },
                  getCheckboxProps: (record: any) => get_checkbox_props?.(record)
                }
              }
            : undefined)}
        />
      </div>
    );
    // eslint-disable-next-line
  }, [
    set_loading_done_items,
    items,
    set_items,
    titles,
    search_value,
    page_number,
    page_size,
    changePage,
    formatMessage,
    menu,
    list_type,
    default_sorter,
    on_select_local,
    selected_row_keys,
    selectable,
    selectable_type,
    expanded_keys,
    get_sub,
    set_item_selected,
    no_title,
    custom_col,
    is_row_operation,
    menu_row,
    no_show_page_size,
    hide_select_all,
    has_on_row_visable,
    get_checkbox_props,
    has_filter
  ]);

  const table_desc_el_0: JSX.Element | undefined = useMemo(
    (): JSX.Element | undefined =>
      table_desc && (
        <div className='card_title management-label-line big_font mt-10 px-20'>
          {table_desc[0]}
          {!!help && (
            <Tooltip title={help.text} placement='right'>
              <span
                className='px-6 pointer'
                onClick={() => {
                  help.url && window.open(help.url);
                }}
              >
                <QuestionCircleFilled />
              </span>
            </Tooltip>
          )}
        </div>
      ),
    [table_desc, help]
  );

  const table_desc_el_1: JSX.Element | undefined = useMemo(
    (): JSX.Element | undefined =>
      table_desc && (
        <div className='card_title_desc no_color small_font mb-5'>
          {table_desc.slice(1, 2).map((item: string | JSX.Element, index: number) => (
            <Fragment key={`table_desc_${index}`}>
              <span className={`${index !== table_desc.length - 2 ? 'mr-80' : ''} mini-display`}>{item}</span>
            </Fragment>
          ))}
        </div>
      ),
    [table_desc]
  );

  const table_title: JSX.Element = useMemo((): JSX.Element => {
    return (
      <Col key={1} sm={24}>
        {table_desc_el_1}
      </Col>
    );
  }, [table_desc_el_1]);

  const table_desc_el_2: JSX.Element | '' | undefined = useMemo(
    (): JSX.Element | '' | undefined => table_desc?.[2] && <div className='no_color small_font mb-5'>{table_desc[2]}</div>,
    [table_desc]
  );

  // 按鈕群組

  const general_button = useMemo(
    () =>
      has_general_button && (
        <Button
          type='primary'
          icon={general_button_icon?.icon || <SettingOutlined />}
          onClick={() => {
            if (operation) {
              const custom_action = operation.find(({ caption }: operation_type) => caption === 'general')?.custom_action;
              const action_new = operation.find(({ caption }: operation_type) => caption === 'general')?.action;
              set_action && set_action(action_new);
              const action_id_new: number = operation.findIndex(({ caption }: operation_type) => ['general']?.includes(caption));
              set_action_id(action_id_new);
              props.set_action_id?.(action_id_new);
              if (custom_action) custom_action({ props });
              else {
                set_action_id(operation.findIndex(({ caption }: operation_type) => ['general'].includes(caption)));
                set_visible?.(1);
                set_item_selected && set_item_selected(undefined);
              }
            }
          }}
        >
          {general_button_icon?.text && (
            <span className='button_label font-14'>
              <FormattedMessage id={general_button_icon?.text} />
            </span>
          )}
        </Button>
      ),
    [general_button_icon?.icon, general_button_icon?.text, has_general_button, operation, props, set_action, set_item_selected, set_visible]
  );

  const create_button = useMemo(
    () =>
      !no_create_button && (
        <Button
          type='primary'
          className={`${has_backup_button && 'backup-button'}`}
          onClick={() => {
            if (operation) {
              const custom_action = operation.find(({ caption }: operation_type) => caption === 'create')?.custom_action;
              set_action?.(0);
              const action_id_new: number = operation.findIndex(({ caption }: operation_type) => [custom_caption, 'create', 'edit']?.includes(caption));
              set_action_id(action_id_new);
              props.set_action_id?.(action_id_new);
              if (custom_action) custom_action({ props });
              else {
                set_visible && set_visible(1);
                set_item_selected && set_item_selected(undefined);
              }
            }
          }}
          icon={<PlusOutlined />}
        >
          {(has_backup_button && (
            <span className='font-14'>
              <FormattedMessage id='immediate_backup' />
            </span>
          )) || (
            <span className='font-14'>
              <FormattedMessage id='add' />
            </span>
          )}
        </Button>
      ),
    [custom_caption, has_backup_button, no_create_button, operation, props, set_action, set_item_selected, set_visible]
  );

  const import_button = useMemo(
    () =>
      has_import_button && (
        <Button
          type='primary'
          shape='circle'
          icon={<ImportOutlined />}
          onClick={() => {
            if (operation) {
              const custom_action = operation.find(({ caption }: operation_type) => caption === 'create')?.custom_action;
              set_action && set_action(0);
              if (custom_action) custom_action({ props });
              else {
                set_action_id(operation.findIndex(({ caption }: operation_type) => ['import'].includes(caption)));
                set_visible?.(1);
                set_item_selected && set_item_selected(undefined);
              }
            }
          }}
        />
      ),
    [has_import_button, operation, props, set_action, set_item_selected, set_visible]
  );

  const refresh_button = useMemo(
    () =>
      !no_refresh_button &&
      (() => {
        const { loading_done, loading_key } = props;
        const is_loading = !loading_done?.[loading_key ?? list_type];
        return (
          <Button
            type='primary'
            {...(loading_done
              ? {
                  icon: <ReloadOutlined spin={is_loading} />,
                  disabled: is_loading
                }
              : { icon: <ReloadOutlined /> })}
            onClick={() => {
              set_loading_done_items ? set_loading_done_items() : set_items?.(undefined);
            }}
          >
            <span className='button_label'>
              <FormattedMessage id='refresh' />
            </span>
          </Button>
        );
      })(),
    [list_type, no_refresh_button, props, set_items, set_loading_done_items]
  );

  const batch_delete_button = useMemo(
    () =>
      has_batch_delete_button && (
        <Button
          type='primary'
          shape='circle'
          disabled={!items?.length ? true : false}
          danger={selectable ? true : false}
          icon={<DeleteOutlined />}
          onClick={() => {
            let operations_format: operation_type[] | undefined = filter_operations && filter_operations.length ? filter_operations : operation;
            !selectable && set_selected_row_keys && set_selected_row_keys([]);
            set_selectable?.(selectable && !selected_row_keys?.length ? 0 : 1);
            if (selectable && selected_row_keys?.length && operations) {
              const custom_action = operations_format?.find(({ caption }: operation_type) => caption === 'batch_delete')?.custom_action;
              if (custom_action) custom_action({ props });
              else {
                let batch_delete_index: number | undefined = operations_format?.findIndex(({ caption }: operation_type) => ['batch_delete'].includes(caption));
                set_action_id(batch_delete_index);
                props.set_action_id?.(batch_delete_index);
                set_action && set_action(2);
                set_visible && set_visible(1);
                set_item_selected && set_item_selected(undefined);
              }
            }
          }}
        />
      ),
    [
      filter_operations,
      has_batch_delete_button,
      operation,
      operations,
      props,
      selectable,
      selected_row_keys?.length,
      set_action,
      set_item_selected,
      set_selectable,
      set_selected_row_keys,
      set_visible,
      items
    ]
  );

  const table_operations: JSX.Element | undefined = useMemo(
    (): JSX.Element | undefined => {
      const { loading_done, loading_key } = props;
      const is_loading = !loading_done?.[loading_key ?? list_type];
      return !no_create_button || !no_refresh_button || has_import_button || has_general_button ? 
      <Row className='tb-opera-div' align='middle' justify='end'>
        <div className={loading_done ? is_loading ? 'cursor-not-allowed': '': ''} style={{ float: 'right'}}>
          <Space className={loading_done ? is_loading ? 'pointer-events-none': '' : ''}>
            {/* 通用类按钮 非 新增 删除 导入 重新獲取 等  */}
            {general_button}
            {/* 新建按鈕 ( has_backup_button 为 1 时则是立即備份按鈕)*/}
            {create_button}
            {/* 导入按钮*/}
            {import_button}
            {/* 重新獲取列表按鈕 */}
            {refresh_button}
            {/* 批量刪除列表按鈕 */}
            {batch_delete_button}
          </Space>
        </div>
      </Row> : undefined
    },
    // eslint-disable-next-line
    [
      set_loading_done_items,
      path,
      props,
      set_action,
      set_action_id,
      no_create_button,
      operations,
      set_visible,
      set_item_selected,
      no_title,
      no_refresh_button,
      has_backup_button,
      has_batch_delete_button,
      has_import_button,
      has_general_button,
      general_button_icon,
      set_items,
      selectable,
      custom_caption
    ]
  );

  return (
    <Row>
      <Col sm={24} className = "ant-card">
        {!!VisibleDelayed(visible) && (
          <TableListModal
            {...props}
            {...{
              visible,
              ...(props.hasOwnProperty('set_action_id') ? {} : { set_action_id }),
              ...(props.hasOwnProperty('action_id') ? {} : { action_id })
              // caption
            }}
          />
        )}
        {!no_title && (
          <Fragment>
            {table_desc_el_0}
            {!!table_desc?.slice(1).length && (
              <Row key='title' className='management-select-area'>
                <Col sm={24}>{table_title}</Col>
              </Row>
            )}
          </Fragment>
        )}
        {!!table_desc_el_2 && (
          <Row key='title' className='table_sub'>
            <Col sm={24}>{table_desc_el_2}</Col>
          </Row>
        )}
        {!props.no_table && (
          <Card bordered={false} style={props.table_card_style}>
            <Row>
              <Col sm={24} className='big_table_title dropdown_menu_parent'>
                <Row className='mb-16'>
                  <Col xl={18}>{dropdown_menu_el}</Col>
                  <Col xl={6}>{table_operations}</Col>
                </Row>
                {table}
              </Col>
            </Row>
          </Card>
        )}
      </Col>
    </Row>
  );
};

// TableList.whyDidYouRender = true;

export default injectIntl(withRouter(TableList));
